export type AccountType = 'web' | 'warden-app' | 'loneworker-app'

export const ACCOUNT_TYPES: readonly AccountType[] = ['web', 'warden-app', 'loneworker-app']
